import React, {Component} from 'react';
import RatingItem from "./RatingItem";
import '@assets/sass/components/rating.scss';

const STAR_COUNT = 5;
const FILL_EMPTY = 'empty';
const FILL_HALF = 'half';
const FILL_FULL = 'full';

export default class Rating extends Component {
    constructor(props) {
        super(props);
        this.calculateStarFillLevel = (starIndex) => {
            if(starIndex <= this.props.rate - 1) {
                return FILL_FULL;
            }

            if(starIndex >= this.props.rate - 1 && this.props.rate - starIndex === 0.5) {
                return FILL_HALF;
            }

            return FILL_EMPTY;
        };

        this.getFillLevels = () => {
            let fillLevels = [];
            for(let i = 0; i < STAR_COUNT; i++) {
                fillLevels.push(this.calculateStarFillLevel(i));
            }
            return fillLevels;
        };
    }

    render() {
        const {rate, colorVersion} = this.props;

        return (
            <div className="rating">
                {rate !== null &&
                    this.getFillLevels().map((fillLevel, index) => {
                        return <RatingItem
                            key={index}
                            fillLevel={fillLevel}
                            colorVersion={colorVersion}
                        />
                    })
                }
            </div>
        );
    }
}
